var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"offline-ch"}},[_c('div',{staticClass:"offline-ch"},[_c('div',{attrs:{"id":"btn"},on:{"click":_vm.hidden}}),_vm._v(" "),_vm._l((_vm.offlineCh),function(el,i){return _c('p',{key:i},[_vm._v(_vm._s(el))])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d11c546a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TotalOfflineCh.vue
// module id = null
// module chunks = 